<div class="login-block">

  <article class="login-article" style="margin-top:1rem">
    <img src="assets/images/logo.jpg" width="300" />
    <hr />
    <p>The On Line Asset Management & Certification System</p>
  </article>


  <form (ngSubmit)="onLogin()" *ngIf="!showMFA && !showForgotPassword && !showReset">
    <article class="login-article" style=" margin-top: 1rem;">
      <p style="width: 100%;">Welcome to the Lifting Gear and Safety Ltd customer website. </p>
      <p style="width: 100%;">Our customers can log in to gain access to their
        equipment inventories and view the status of inspections</p>


      <div style="margin-top: 1rem;width:100%">
        <label>Email</label>
        <input type="email" class="form-control" [(ngModel)]="email" name="email" />
      </div>

      <div style="width:100%">
        <label>Password</label>
        <input type="password" class="form-control" [(ngModel)]="password" name="password" />
      </div>


      <div class="btn-container">
        <input type="button" value="Forgot Password"  style="min-height: 50px;" class="btn btn-secondary" (click)="showPassword()" />
        <input type="submit" style="min-height: 50px;" class="btn btn-primary" value="Login" />

      </div>

      <p *ngIf="invalid" class="danger-text">Invalid Email/Password.</p>
    </article>

  </form>


  <form (ngSubmit)="confirmMFAPassword()" *ngIf="showMFA && !showForgotPassword && !showReset">
    <article class="login-article" style=" margin-top: 1rem;">
      <div style="display: flex; display: flex; flex-direction: column;">
        <h5>Please enter the code that was sent to your email</h5>
      </div>
      <div class="input-group" style="width:100%">
        <div class="input-group" style="width: 100%;justify-content: center;">
          <ng-otp-input name="otp" [config]="{ length: 6 }" ngDefaultControl
            (onInputChange)="onOtpChange($event)"></ng-otp-input>

        </div>
      </div>

      <div class="btn-container">
        <input type="button" value="Back to Login" class="btn btn-secondary" style="min-height: 50px;" (click)="showLogin()" />
        <input type="submit" value="Confirm"  style="min-height: 50px;" class="btn btn-primary pull-right" />

      </div>




    </article>

  </form>


  <form (ngSubmit)="passwordReset()" *ngIf="showForgotPassword">
    <article class="login-article" style=" margin-top: 1rem;">
      <div style="margin-top: 1rem;width:100%">
        <label>Email</label>
        <input type="email" class="form-control" [(ngModel)]="email" name="email" />
      </div>
      <div class="btn-container">
        <input type="button" value="Back to Login" class="btn btn-secondary" style="min-height: 50px;" (click)="showLogin()" />
        <input type="submit" style="min-height: 50px;" class="btn btn-primary" value="Reset" />

      </div>
    </article>

  </form>

  <form (ngSubmit)="confirmResetPassword()" *ngIf="showReset">
    <article class="login-article" style=" margin-top: 1rem;">
       <div style="width:100%">
        <label>Password</label>
        <input type="password" class="form-control" [(ngModel)]="password" name="password" />
      </div>
      <div style="width:100%">
        <label>Confirm Password</label>
        <input type="password" class="form-control" [(ngModel)]="passwordConfirm" name="passwordConfirm" />
      </div>

      <div class="btn-container">
        <input type="button" value="Back to Login" class="btn btn-secondary" style="min-height: 50px;" (click)="showLogin()" />
        <input type="submit" style="min-height: 50px;" class="btn btn-primary" value="Reset" />

      </div>
    </article>

  </form>


  <div style="display: flex;flex-direction: row;margin-top:1rem">
    <article class="login-article-minor minor-article-start">
      <img src="assets/images/checkedok.png" width="150" />

    </article>


    <article class="login-article-minor minor-article-end">
      <img src="assets/images/coreRFID.png" width="150" />

    </article>
  </div>
</div>